/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { BlacklistItemValidityDtoModel } from './blacklist-item-validity-dto-model';
import { DelCustomerExtendedVO } from './del-customer-extended-vo.model';

export class CustomerBlacklistItemDtoModel {
  uuid: string | null = null;
  owner: string | null = null;
  delCustomerExtendedVO: DelCustomerExtendedVO | null = null;
  blacklistItemValidityDTO: BlacklistItemValidityDtoModel | null = null;
}
